import React from 'react';

export const BuyboxSocialShare = (props: {socialShare: React.ReactNode[]}): JSX.Element | null => {
    const { socialShare } = props;
    if (!socialShare || socialShare?.length === 0) {
        return null;
    }

    return <>{socialShare[0]}</>;
};
